import { gql } from './graphql';
import { Facility } from '../utils/facilityStorage';

const FACILITIES = `
  query Facilities {
    facilities {
      id
      name
      facility_alias
    }
  }
`;

export async function fetchFacilities(): Promise<Facility[]> {
  const data = await gql<{ facilities: Facility[] }>(FACILITIES);
  return data.facilities;
}
